<template>
    <CModal
            v-model="dialogVisible"
            id="dsh"
            width="1200px"
            footerHide
            title="详情">
        <div class="form-area">
            <Form style="width: 1000px" v-loading="loading" :model="model" ref="form" :rules="rules" :label-width="100"
                  label-position="left"
                  inline>
                <FormItem label="服务机构名称" prop="serviceName">
                    <Input readonly v-model="model.serviceName" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="创建时间" prop="createTime">
                    <Input readonly v-model="model.createTime" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="机构分类" prop="serviceTypeName">
                    <Input readonly v-model="model.serviceTypeName" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="机构简介" prop="introduct">
                    <Input readonly v-model="model.introduct" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="机构人数" prop="staffCount">
                    <Input readonly v-model="model.staffCount" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="联系人" prop="contactMan">
                    <Input readonly v-model="model.contactMan" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="联系方式" prop="contactManTel">
                    <Input readonly v-model="model.contactManTel" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="机构地址" prop="address">
                    <Input readonly v-model="model.address" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="所在区域" prop="area">
                    <Input readonly :value="model.city+' / '+model.area+' / '+model.town" style="width:320px" type="text"></Input>
                </FormItem>
                <br>
                <FormItem label="服务机构logo" prop="totalPeopleCount">
                    <previewImg :src="model.serviceLogo.url" style="width: 200px;height: 160px" v-if="model.serviceLogo && model.serviceLogo.url" />
                    <img style="width: 200px;height: 160px" v-else src="../../../../assets/noPic.jpg" alt="">
                </FormItem>
                <FormItem label="营业执照" prop="totalPeopleCount">
                    <previewImg :src="model.businessLicense.url" style="width: 150px;height: 150px" v-if="model.businessLicense && model.businessLicense.url" />
                    <img style="width: 200px;height: 160px" v-else src="../../../../assets/noPic.jpg" alt="">
                </FormItem>
                <br>
                <FormItem style="width:100%;margin-right:0;" label="荣誉资质" prop="honor">
                    <Input :rows="6" readonly v-model="model.honor" type="textarea"></Input>
                </FormItem>
                <br>
                <FormItem style="width:100%;margin-right:0;" v-if="model.honorImg && model.honorImg.length > 0" label=""
                          prop="totalPeopleCount">
                    <div class="flex-wrap">
                        <previewImg v-for="(item) in model.honorImg" :key='item.url' :src="item.url" style="width: 150px;height: 150px" />
                    </div>
                </FormItem>
                <FormItem v-else label="" prop="totalPeopleCount">
                    <img style="width: 200px;height: 160px" src="../../../../assets/noPic.jpg" alt="">
                </FormItem>
                <template v-if="model.status == 2">
                    <br>
                    <FormItem label="审核状态" prop="statusName">
                        <Input readonly v-model="model.statusName" style="width:320px" type="text"></Input>
                    </FormItem>
                    <br>
                    <FormItem label="审核时间" prop="updateTime">
                        <Input readonly v-model="model.updateTime" style="width:320px" type="text"></Input>
                    </FormItem>
                    <br>
                    <FormItem label="拒绝原因" prop="examineRemark">
                        <Input readonly v-model="model.examineRemark" style="width:320px" type="text"></Input>
                    </FormItem>
                </template>

            </Form>
        </div>
        <div class="form-area" v-if="model.status == 0">
            <Button type="primary" @click="pass">审核通过</Button>
            <Button style="margin-left: 10px" type="warning" @click="reject">审核拒绝</Button>
        </div>
        <el-dialog
                id="myDialog"
                :visible.sync="showBig"
                :append-to-body="true"
                @close="close"
        >
            <div style="justify-content: center;display: flex">
                <img class="img" :src="bigPic" alt=""/>
            </div>
        </el-dialog>
    </CModal>
</template>

<script>
    import CModal from '@/components/cModel'
    import previewImg from '@/components/previewImg'
    export default {
        components: {CModal,previewImg},

        data () {
            return {
                dialogVisible: false,
                showBig: false,
                bigPic: '',
                model: {},
                rules: {},
                id: '',
                loading: false
            }
        },
        watch: {
            id (val) {
                this.detail(val)
            }
        },
        mounted () {
        },
        methods: {
            detail (id) {
                if (id) {
                    this.loading = true
                    this.$util.http.get(`/api/tqtServiceExaminesDetails/${id}`).then(res => {
                        this.model = res.data
                    }).finally(() => {
                        this.loading = false
                    }
                )
                }
            },
            cancel () {
                this.dialogVisible = false
                this.id = ''
                this.model = {}
            },
            pass () {
                this.$confirm('即将审核通过?', '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                }).then(() => {
                    this.$http.post('/api/tqtServiceExamines/sign', {
                        id: this.model.id,
                        status: 1
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '审核通过!'
                        })
                        this.cancel()
                        // 你们不要学我啊 请使用$emit
                        this.$parent.$parent.$parent.$parent.$refs['yishenhe'].listTable()
                        this.$parent.listTable()
                    }).catch(res => {
                        this.$message({
                            type: 'warning',
                            message: '审核失败'
                        })
                    })

                })
            },
            reject () {
                this.$prompt('请输入拒绝原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '拒绝原因不能为空'
                }).then(({ value }) => {
                    this.$http.post('/api/tqtServiceExamines/sign', {
                        id: this.model.id,
                        status: 2,
                        examineRemark: value,
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '已拒绝!'
                        })
                        this.cancel()
                        this.$parent.listTable()
                    }).catch(res => {
                        this.$message({
                            type: 'warning',
                            message: '拒绝已取消！'
                        })
                    })
                })
            },
            showBigPic (val) {
                this.bigPic = val
                this.showBig = true
            },
            close(){
                this.bigPic = ''
                this.showBig = false
            }
        }
    }
</script>

<style lang="less">
    #dsh {
        .form-area {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .ivu-form-item {
            width: 450px;
            margin-left: 40px;
        }

        .ivu-modal-footer {
            display: none;
        }
        img {
            cursor: pointer;
        }
    }
    #myDialog{
        .el-dialog{
            background: transparent !important;
            box-shadow: none;
            .el-icon-close:before{
                content: '';
            }
        }
    }
    .flex-wrap{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    .flex-wrap>div{
        margin-right: 20px;
    }
</style>
